enum apiFields {
  httpMethod = 'httpMethod',
  username = 'username',
  email = 'email',
  url = 'url',
}

export { apiFields };
